// extracted by mini-css-extract-plugin
export default {"container":"EquationInput_container__WbpNq","field":"EquationInput_field__aDWjN","input":"EquationInput_input__nUfc+"};